export enum SubscriptionStatus {
  'pending' = 'pending',
  'trial' = 'trial',
  'active' = 'active',
  'canceled' = 'canceled',
  'expired' = 'expired',
  'past_due' = 'past_due'
}
